
  import { Watch, Prop, Mixins, Component, Ref, InjectReactive } from "vue-property-decorator";
  
  import ETable from "@/components/ETable.vue";
  import tablePagination from "@/mixins/tablePagination";
  import loading from "@/mixins/loading";
  import Resize from "@/mixins/resize";
  
  import { getShareComboUserList } from "@/api/shareGroup";

  import AddCustomSelf from "./addCustomSelf.vue";
  import CustomSelfDetail from "./customSelfDetail.vue";

  import { cloneDeep } from "lodash";
  
  @Component({ name: 'shareDevice-components-customSelfList',
      components: { ETable, AddCustomSelf, CustomSelfDetail }
  })
  export default class CustomSelfList extends Mixins(tablePagination, loading, Resize) {

      @InjectReactive() currentTab !: string;

      [x: string]: any;

      tabListSurplusHeight = 100;
  
      queryForm = {
          phone: "",
          userName: "",
      };
  
      itemTotal = 0;
      tableData = [];
  
      columns = [
          { label: "用户ID", prop: "userId" },
          { label: "用户头像", prop: "icon" },
          { label: "用户名称", prop: "nickname" },
          { label: "用户手机号", prop: "phone" },
          { label: "总剩余次数", prop: "remainingNum" },
          { label: "总消费次数", prop: "", formatter: (row) => row.comboNum - row.remainingNum },
          { label: "操作", width: "200", fixed: "right", prop: "action" },
      ];
  

      formVisible = false;

      detailVisible = false;

      form = {};
      detailInfo = {};

      mounted() {
          this.windowResize(800);
          this.getData();
      }

      @Watch("currentTab")
  
      handleSearch() {
          if (this.currentTab !== "1") return;
          this.resetCurrent();
          this.getData();
      }

  
      getData() {
          this.showLoading();
          const params = {
              ...this.queryForm,
              pageNum: this.currentPage,
              pageSize: this.pageSize,
          }
          getShareComboUserList(params).then(res => {
              this.tableData = res.data.list;
              this.itemTotal = res.data.total;
          }).finally(() => {
              this.hideLoading();
          })
      }

      add() {
        this.formVisible = true;
      }

      detail(row) {
        this.detailInfo = cloneDeep(row);
        this.detailVisible = true;
      }

      chargeList(row) {
        this.$emit("syncCurrentTab", { currentTab: "2", ...row })
      }

      expenseList(row) {
        this.$emit("syncCurrentTab", { currentTab: "3", ...row })
      }

  }
  